export interface StarRole {
  title: string;
  note: string;
}

export const starProfile = {
  name: "叶山小百合",
  romajiName: "Hayama Sayuri",
  birthday: "1995 年 4 月 12 日",
  birthplace: "日本 · 神奈川",
  height: "163 cm",
  debut: "2016 年",
  agency: "青云艺能事务所",
  avatar:
    "https://readdy.ai/api/search-image?query=elegant%20studio%20portrait%20of%20a%20graceful%20young%20Japanese%20woman%20with%20shoulder-length%20black%20hair%20in%20a%20simple%20dark%20blouse%2C%20soft%20directional%20lighting%2C%20neutral%20warm%20gray%20background%2C%20editorial%20magazine%20photography%2C%20refined%20and%20calm%2C%20subtle%20film%20grain&width=600&height=750&seq=yh-avatar-01&orientation=portrait",
  intro:
    "叶山小百合是日本女演员，2016 年以配角身份进入影视行业，凭借扎实的表演与鲜明的镜头感逐渐成为同代中最受关注的演员之一。她擅长塑造内敛而坚韧的女性角色，无论是时代剧中的女武士、都市悬疑里的记者，还是安静细腻的文艺女主角，都能呈现出独特的层次感。",
  belief: "「我更在意一个角色有没有没说出口的部分。把情绪说满很简单，把留白交给观众才最难。」",
  timeline: [
    { year: "2016", text: "参演首部影视作品，正式出道。" },
    { year: "2019", text: "凭借时代剧《月照长街》获得关注，走进大众视野。" },
    { year: "2021", text: "以《无声之刃》中的动作表演获得业内肯定。" },
    { year: "2023", text: "主演《樱色信笺》，首次入围最佳女主角。" },
    { year: "2024", text: "主演犯罪悬疑电影《雾港夜航》，挑战水下拍摄。" },
  ],
};

export const starRoles: StarRole[] = [
  { title: "深津玲《雾港夜航》", note: "冷峻克制的潜水调查员" },
  { title: "三浦葵《东京回声》", note: "执着真相的调查记者" },
  { title: "绫《无声之刃》", note: "沉默隐忍的时代女武士" },
  { title: "早川茜《樱色信笺》", note: "安静温柔的图书管理员" },
];

export const siteInfo = {
  name: "叶山小百合影视资料站",
  slogan: "记录一位演员的光影旅程",
  intro:
    "本站是专注整理叶山小百合参演影视作品与相关资讯的资料型站点。我们汇集其电影、电视剧的完整资料，收录剧情简介、演职人员、剧照与播出信息，并持续更新最新动态，帮助影迷与影视研究者快速、全面地了解叶山小百合的作品轨迹。",
  email: "contact@hayama-sayuri.example",
  address: "日本 · 东京都 · 影视文化区 3-12-8",
  note: "本站为非营利性影迷资料整理站点，所有内容仅用于作品介绍与资讯展示，不提供影片播放或下载服务。",
};